/**
 * Knihovna pro práci s google recatpcha
 *
 * Pokud je na stránce element s parametrem data-spam-key tak se vloží skripty recatpchy
 * Následně se hledají elementy s atributem data-spam, kde hodnotou lze vyjádřit názve inputu(name="xxx")
 * Pokud není v data-spam platný název inputu, tak se zkusí vyhledat input s name="spamToken"
 * Pokud se nepodaří najít žádný input kam se dá zapsat token tak se kontrola neprování
 */



function addScripts(key, callback) {
    if(key) {
        let googleReCaptchaUrl = `https://www.recaptcha.net/recaptcha/api.js?render=${key}`;

        if (!document.querySelectorAll(`[src="${googleReCaptchaUrl}"]`).length) {
            document.body.appendChild(Object.assign(
                document.createElement('script'), {
                    type: 'text/javascript',
                    src: googleReCaptchaUrl,
                    onload: callback
                })
            );
        }
    }
}

function getKey() {
    let recaptchaKey = document.querySelector('[data-spam-key]');
    return recaptchaKey ? recaptchaKey.getAttribute('data-spam-key') : null;
}

document.addEventListener("DOMContentLoaded", function() {
    initialize();
});

function initialize() {
    let recaptchaKey = getKey();
    let areas = document.querySelectorAll('[data-spam]');

    if(recaptchaKey && areas.length) {
        addScripts(recaptchaKey);
        areas.forEach(function(formElement) {
            if(formElement.hasOwnProperty('gainitialized') === false) {
                formElement.addEventListener('submit', function(event) {
                    formElement.gainitialized = true;
                    let ajaxFormActive = formElement.ajaxFormActive || false;
                    let recaptchaFormSubmitted = formElement.recaptchaFormSubmitted || false;
                    if(ajaxFormActive === false && recaptchaFormSubmitted === false) {
                        event.preventDefault();
                        apply(formElement, function() {
                            formElement.recaptchaFormSubmitted = true;
                            formElement.submit();
                        });
                    }
                });
            }
        });
    }
}

export function apply(form, callback) {
    let action = '';

    if (form.hasAttribute('data-spam')) {
        action = form.getAttribute('data-spam') || 'spamToken';
    }

    if(action !== '') {
        let input = form.querySelector('[name="spamToken"]');

        if(input === null) {
            input = form.querySelector('[name="' + action + 'Value"]');
        }

        if(action && input) {
            let recaptchaKey = getKey();

            grecaptcha.ready(function() {
                grecaptcha.execute(recaptchaKey, {action: action}).then(function(token) {
                    input.value = token;
                    callback();
                });
            });

            return;
        }
    }

    callback();
}
